<template>
    <div :class="print_version ? 'mx-1' : ''">
        
        <div v-if="!readyToLoad" class="text-center py-12 my-12" style="width: 100%">
            <v-progress-circular
                indeterminate 
                color="error darken-3" 
                class="my-12 py-12" 
                size="100" 
                width="8">
            </v-progress-circular>
        </div>
        <div v-else>
            <div v-if="print_version" class="mb-6 py-3" style="border-bottom:2px solid #002244">
                <div class="d-flex d-block justify-space-between py-3">

                    <div class="d-inline justify-start" style="width: 65%">
                        <div class="d-flex d-block align-center my-2">
                            <!-- <customIcon :name="printablePrj.modinfo.module_key" class="d-inline ml-n2 mr-1 mt-n1 primary--text text--darken-2 icon-size-header" /> -->
                            <div class="d-inline sansation align-start">
                                <span v-html="printablePrj.project_label"></span>
                            </div>
                        </div>
                        <div class="d-block align-start my-2">
                            <div v-for="owner in printablePrj.project_owners" :key="owner.user_id">
                                <span class="sansation font-weight-bold lend--text">{{ owner.first_name }} {{ owner.last_name }}</span><br>
                                <span class="sansation grey--text text--darken-2">{{ owner.user_email }}{{ owner.phone ? ' | '+owner.phone.trim() : '' }}</span>
                            </div>

                            <div v-if="printablePrj.project_secondary_users && printablePrj.project_secondary_users.length">
                                <div class="mt-3 caption">Additional Users</div>
                                <div v-for="secondary in printablePrj.project_secondary_users" :key="secondary.user_id" class="mt-n2">
                                    <ul class="avenir_book mt-2">
                                        <li>{{ secondary.first_name }} {{ secondary.last_name }}</li>    
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-inline justify-end" style="max-width: 35%">
                        <div class="d-flex d-block justify-end align-center my-2 sansation">
                            <div v-if="printablePrj.secondary_access" class="d-inline mr-2"><v-icon color="general_grey lighten-2" class="mt-n1">mdi-account-multiple-plus</v-icon></div>
                            <div class="d-inline error--text text--darken-3 mr-1" v-if="printablePrj.expedite">Expedited ::</div>
                            <div class="d-inline mr-2 general_grey--text">Status:</div>
                            <div class="d-inline" :class="printablePrj.status_text_color">
                                {{ printablePrj.status_internal_label }}
                            </div>
                        </div>

                        <div class="d-flex d-block justify-end align-start my-2 sansation">
                            <div class="d-inline mr-2 general_grey--text">Project Completion:</div>
                            <div class="d-inline" :class="printablePrj.status_text_color">
                                {{ printablePrj.complete }}%
                            </div>
                        </div>

                        <div class="d-flex d-block justify-end align-start my-2 sansation">
                            <div class="d-inline mr-2 general_grey--text">{{ printablePrj.status == 'complete' ? 'Completion Date:' : 'Est. Completion Date:' }}</div>
                            <div class="d-inline primary--text text--darken-2">{{ printablePrj.close_date ? formatDate(printablePrj.close_date, 'mmmm d, yyyy') : 'NA' }}</div>
                        </div>

                        <div class="d-flex d-block justify-end align-start my-2 sansation">
                            <div v-if="printablePrj.modinfo.module_key != 'entity-maintenance-program'">
                                <div class="d-inline mr-2 general_grey--text">Current Step:</div>
                                <div class="d-inline primary--text text--darken-1">
                                    <span v-if="printablePrj.stage_name_text == 'How Did We Do?'">
                                        {{ printablePrj.stage_name_text }} <v-icon color="warning" class="mt-n1 ml-3">mdi-star-face</v-icon> (survey takes less than a minute)
                                    </span>
                                    <span v-else>
                                        {{ printablePrj.stage_name_text }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-block align-center">
                <div class="d-flex justify-end sansation label_medium info--text">
                    <!-- <div class="justify-start">Project Steps</div> -->
                    <div class="justify-end" style="z-index: 1">
                        <v-btn v-if="!print_version && currentTab === 'tab_steps'"
                            small  
                            outlined  
                            color="primary darken-2"
                            elevation="0"
                            class="mr-2"
                            @click="openStepDialog">
                            New Milestone
                        </v-btn>
                        <v-btn v-if="!print_version && currentTab === 'tab_meetings'"
                            small   
                            outlined
                            color="primary darken-2"
                            elevation="0"
                            class="mr-2"
                            @click="openMeetingDialog">
                            New Meeting
                        </v-btn>

                        <v-btn v-if="!print_version && currentTab === 'tab_steps'"
                            small
                            outlined
                            color="error darken-2"
                            elevation="0"
                            class="mr-2"
                            @click="removeAllMilestones()">
                            Remove all Milestones
                        </v-btn>
                        
                        <v-btn v-if="!print_version && currentTab === 'tab_steps'"
                            small
                            outlined
                            color="status_upgrade darken-1"
                            elevation="0"
                            class="mr-2"
                            @click="showAllTasks()">
                            {{ showAllTaskRows ? 'Show visible Tasks only' : 'Show all Tasks' }}
                        </v-btn>

                        <v-btn v-if="print_version"
                            small    
                            outlined
                            color="grey lighten-4"
                            elevation="0"
                            class="error--text text--darken-3 mr-2"
                            @click="printClose()">
                            close
                        </v-btn>
                        <v-btn 
                            small
                            outlined
                            color="status_upgrade darken-1"
                            elevation="0"
                            @click="print_version ? printPsrReport() : printPsrWindow()">
                            print
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-dialog 
                v-model="chooseLeadOnMeeting" 
                width="500px"
                persistent>
                <v-card>
                    <v-card-title class="primary lighten-2 info--text">
                        Choose a lead for this meeting
                    </v-card-title>
                    <v-card-text class="py-4">
                        <v-select
                            v-model="editedMeeting.lead_id"
                            :items="meetingLeadNames"
                            label="Meeting Lead"
                            persistent-hint
                            hint="Select who's Calendly URL will be used for this meeting."
                            item-text="text"
                            item-value="value"
                        />
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn 
                            color="primary" 
                            outlined 
                            @click="chooseLeadOnMeeting = false">
                            Cancel
                        </v-btn>
                        <v-btn 
                            color="primary" 
                            @click="saveMeetingWithLead()">
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-navigation-drawer
                v-model="projectReportStepDialog"
                temporary
                absolute
                right
                width="46%"
                overlay-opacity="0"
                class="drawer-shadow">
                <v-card flat class="drawer-content">
                    <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                        <div class="d-inline">
                            {{ dialogTitle('projectReportStepDialog') }}
                        </div>
                        <div class="d-inline">
                            <v-btn 
                                icon
                                outlined
                                color="info"
                                elevation="1"
                                @click="closeNavigationDrawer('projectReportStepDialog')">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <ProjectReportStepDialog
                            :item="editedStep"
                            @save="save"
                            @close="close"
                        />
                    </v-card-text>
                </v-card>
            </v-navigation-drawer>

            <v-navigation-drawer
                v-model="projectTaskDialog"
                temporary
                absolute
                right
                width="46%"
                overlay-opacity="0"
                class="drawer-shadow">
                <v-card flat class="drawer-content">
                    <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                        <div class="d-inline">
                             {{ dialogTitle('projectTaskDialog') }}
                        </div>
                        <div class="d-inline">
                            <v-btn 
                                icon
                                outlined
                                color="info"
                                elevation="1"
                                @click="closeNavigationDrawer('projectTaskDialog')">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <ProjectReportDialog
                            :editedItem="editedItem"
                            :drawerOpen="projectTaskDialog"
                            @save="save"
                            @next-task="loadNextTask"
                            @close="close"
                        />
                    </v-card-text>
                </v-card>
            </v-navigation-drawer>

            <v-navigation-drawer
                v-model="projectReportMeetingDialog"
                temporary
                absolute
                right
                width="46%"
                overlay-opacity="0"
                class="drawer-shadow">
                <v-card flat class="drawer-content">
                    <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                        <div class="d-inline">
                            {{ dialogTitle('projectReportMeetingDialog') }}
                        </div>
                        <div class="d-inline">
                            <v-btn 
                                icon
                                outlined
                                color="info"
                                elevation="1"
                                @click="closeNavigationDrawer('projectReportMeetingDialog')">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <ProjectReportMeetingDialog
                            :editedItem="editedMeeting"
                            @save="save"
                            @close="close"
                        />
                    </v-card-text>
                </v-card>
            </v-navigation-drawer>

            <v-navigation-drawer
                v-model="reorderTasksDialog"
                temporary
                absolute
                right
                width="46%"
                overlay-opacity="0"
                class="drawer-shadow">
                <v-card flat class="drawer-content">
                    <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                        <div class="d-inline">
                            {{ dialogTitle('reorderTasksDialog') }}
                        </div>
                        <div class="d-inline">
                            <v-btn 
                                icon
                                outlined
                                color="info"
                                elevation="1"
                                @click="closeNavigationDrawer('reorderTasksDialog')">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <ProjectReportTaskReorderDialog
                            :projectStep="this_Milestone"
                            @close="close"
                        />
                    </v-card-text>
                </v-card>
            </v-navigation-drawer>

            <v-navigation-drawer
                v-model="calendlyDialog"
                temporary
                absolute
                right
                width="46%"
                overlay-opacity="0"
                class="drawer-shadow">
                <v-card flat class="drawer-content">
                    <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                        <div class="d-inline">
                            {{ dialogTitle('calendlyDialog') }}
                        </div>
                        <div class="d-inline">
                            <v-btn 
                                icon
                                outlined
                                color="info"
                                elevation="1"
                                @click="closeNavigationDrawer('calendlyDialog')">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text class="pt-3 px-0 mx-0">
                        <div id="calendly_wrapper" ref="calendlyWrapper"></div>
                    </v-card-text>
                </v-card>
            </v-navigation-drawer>
            
            <div v-if="projectStepsComputed.length">
                <v-tabs
                    v-model="tab"
                    class="sansation mt-n9"
                    hide-slider>
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab
                        v-for="item in items"
                        :key="item"
                        class="px-3 my-1"
                    >
                        {{ labels[item] }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="steps"
                    >
                        <div class="d-block my-5 align-center" v-for="(project_step, index) in projectStepsComputed" :key="index">
                            <div class="d-flex sansation label_small info--text align-center">
                                {{ project_step.label }}

                                <span class="ml-2 d-inline">
                                    ({{ visibleTaskCount(project_step.tasks) }} / {{ project_step.tasks.length }})
                                </span>

                                <v-btn
                                    v-if="!print_version" 
                                    x-small 
                                    outlined
                                    elevation="0"
                                    class="mt-1 ml-2 info--text"
                                    @click="toggleMilestoneTasks(project_step, hasHiddenTasks(project_step.tasks))">
                                    {{ hasHiddenTasks(project_step.tasks) ? 'mark hidden tasks visible' : 'mark allowed tasks invisible' }}
                                </v-btn>

                                <v-icon
                                    v-if="!print_version"
                                    class="ml-2 d-inline info--text text--lighten-1"
                                    title="Create a new task"
                                    @click="createTask(project_step)">
                                    mdi-plus-box
                                </v-icon>

                                <v-icon
                                    v-if="!print_version && project_step.tasks.length >= 2"
                                    class="ml-2 d-inline info--text text--lighten-1"
                                    title="Reorder tasks"
                                    @click="openTaskDialog(project_step)">
                                    mdi-swap-vertical
                                </v-icon>
                            </div>
                            
                            <v-data-table
                                v-if="showTasks && visibleTasks(project_step.tasks).length"
                                :headers="headers"
                                :items="visibleTasks(project_step.tasks)"
                                :items-per-page="-1"
                                :class="print_version ? 'psr_data_class table_borders' : 'psr_data_class'"
                                hide-default-header
                                hide-default-footer
                            >
                                <template v-slot:header="{ props }">
                                    <tr>
                                        <th v-for="header in props.headers" :key="header.text" :class="header.class">
                                            {{ header.text }}
                                        </th>
                                    </tr>
                                </template>

                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item) in items" 
                                        :key="item.name"
                                        style="cursor: pointer"
                                        :class="item.is_visible ? '' : 'grey--text text--lighten-1'">

                                        <td class="psr_data_class text-start first-column-padding" @click="editTask(project_step, item)">{{ item.label }}</td>
                                        <td class="psr_data_class text-start" @click="editTask(project_step, item)">
                                            {{ labels[`step_status_${item.status}`] }}
                                        </td>
                                        <!-- <td class="psr_data_class text-start align-content-start">
                                            <v-select
                                                :value="item.status"
                                                :items="statusSelectOptions"
                                                item-text="text"
                                                item-value="value"
                                                class="inline_status_select mr-3 mt-n1"
                                                dense
                                                solo
                                                hide-details
                                                @change="updateTaskStatus(project_step, item, $event)">
                                            </v-select>
                                        </td> -->
                                        <td class="psr_data_class text-start" @click="editTask(project_step, item)">{{ labels[`step_priority_${item.priority}`] }}</td>
                                        <td class="psr_data_class text-start" @click="editTask(project_step, item)">{{ labels[`step_complexity_${item.complexity}`] }}</td>
                                        <td class="psr_data_class text-start" @click="editTask(project_step, item)">{{ labels[`step_party_${item.responsible_party}`] }}</td>
                                        <td class="psr_data_class text-start" @click="editTask(project_step, item)">{{ item.owner_id ? ownerItems[item.owner_id] : '' }}</td>
                                        <td class="psr_data_class text-center" @click="editTask(project_step, item)">
                                            <v-icon 
                                                :color="item.internal ? item.is_visible ? 'primary' : 'grey lighten-2' : 'error'"
                                                :title="item.internal ? 'Internal Only' : 'External'">
                                                {{ item.internal ? 'mdi-check' : 'mdi-close' }}
                                            </v-icon>
                                        </td>
                                        <td class="psr_data_class text-center" @click="editTask(project_step, item)">{{ item.duration }}</td>
                                        <td class="psr_data_class text-end" @click="editTask(project_step, item)">{{ formatDate(item.date) }}</td>
                                        <td class="psr_data_class text-end" @click="editTask(project_step, item)">{{ formatDate(item.assigned_date) }}</td>
                                        <td class="psr_data_class text-end" @click="editTask(project_step, item)">{{ formatDate(item.completed_date) }}</td>
                                        <td class="psr_data_class text-end pt-2">
                                            <v-icon 
                                                class="mr-3"
                                                :color="item.is_visible ? 'primary' : 'grey lighten-2'"
                                                @click="hideTask(item, !item.is_visible)">
                                                {{ item.is_visible ? 'mdi-eye-off' : 'mdi-eye' }}
                                            </v-icon>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>                        
                            </v-data-table>
                        </div>
                    </v-tab-item>
                    <v-tab-item
                        key="meetings"
                    >
                        <div class="section-wrapper">
                            <v-data-table
                                :headers="meeting_headers"
                                :items="meetingData"
                                :options.sync="meeting_options"
                                class="elevation-1"
                                hide-default-footer
                            >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="(item) in items" :key="item.label">
                                            <td class="psr_avenir_book">{{ item.label }}</td>
                                            <td class="psr_avenir_book" v-html="item.non_calendly_reason"></td>
                                            <td class="psr_avenir_book">{{ item.start_time ? formatDateTime(item.start_time) : item.calendly_event_id ? 'gathering meeting details' : '' }}</td>
                                            <td class="psr_avenir_book">{{ meetingStatusItems[item.status] }}</td>
                                            <td class="d-flex justify-end px-0">
                                                <v-icon
                                                    class="mr-2"
                                                    @click="scheduleMeeting(item)"
                                                    :title="item.start_time ? `Reschedule Meeting` : `Schedule Meeting`"
                                                >
                                                    mdi-calendar
                                                </v-icon>
                                                <v-icon
                                                    @click="editMeeting(item)"
                                                    title="Edit Meeting"
                                                >
                                                    mdi-dots-vertical
                                                </v-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>                        
                            </v-data-table>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
            <div class="d-block my-5 align-center" v-else>
                <div class="sansation label_small info--text">No project steps available</div>
            </div>
        </div>
    </div>
</template>


<script>  
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment';

    import { 
        meetingStatusItems, 
        taskStatusItems, 
        responsiblePartyItems, 
        priorityItems,
        complexityItems,
        ownerItems,
        taskTypes
    } from '../helpers/constants';

    import ProjectReportDialog from './ProjectReportDialog.vue';
    import ProjectReportStepDialog from './ProjectReportStepDialog.vue';
    import ProjectReportMeetingDialog from './ProjectReportMeetingDialog.vue';
    import ProjectReportTaskReorderDialog from './ProjectReportTaskReorderDialog.vue';

    const calendlyListeners = [];

    export default {
        name: 'ProjectReport',

        components: {
            ProjectReportDialog,
            ProjectReportStepDialog,
            ProjectReportMeetingDialog,
            ProjectReportTaskReorderDialog,
        },

        props: {
            projectDetails: Object,
            formatThisDate: Function,
        },

        watch: {            
            projectDetails: {
                async handler(val){
                    if (val) {
                        await this.getStatusReport();
                    }
                }, "deep": true
            },

            projectStep: {
                handler(val) {
                    this.localProjectStep = JSON.parse(JSON.stringify(val)); // Update local copy when prop changes
                },
                deep: true
            },

            calendlyDialog (isOpen) {
                if (isOpen) {
                    this.initCalendlyWidget();
                }
            }
        },

        computed: {
            projectStepsComputed () {
                return this.projectStepData.map((thisProjectStep) => {
                    const tasks = thisProjectStep.tasks.map((thisTask) => {
                        const relatedItem = this.getRelatedItem(thisTask) || {};
                        // Attach the start_time from the related item to the task for rendering the table
                        return {
                            ...thisTask,
                            start_time: relatedItem.start_time && relatedItem.start_time.replace(':00+00', '')
                        }
                    })
                    
                    return {
                        ...thisProjectStep,
                        tasks
                    };
                });
            },

            meetingURL () {
                const { calendly_invitee_id } = this.editedMeeting && this.editedMeeting.item;

                if (calendly_invitee_id) {
                    return `https://calendly.com/reschedulings/${calendly_invitee_id}`;
                } else {
                    let calendly_meetingURL = this.projectDetails.modinfo.srg_team.teamcal;

                    if (this.projectDetails.expedite) {
                        calendly_meetingURL = this.projectDetails.modinfo.srg_team.teamcal_expedited || calendly_meetingURL;
                    }

                    if ( this.projectDetails.modinfo.module_key === 'enterprise-consulting' ) {
                        calendly_meetingURL = this.enterprise_consulting_meetingURL || calendly_meetingURL;
                    }
                    
                    return calendly_meetingURL;
                }
            },

            meetingLeadNames () {
                if ( !this.projectDetails.project_team ) return [];
                
                const leadNames = this.projectDetails.project_team.map( member => {
                    if ( member.can_lead_meetings ) {
                        return {
                            value: member.user_id,
                            text: `${member.name}`
                        };
                    }
                }).filter(member => member !== undefined);
                return leadNames;
            },

            ownerList () {
                return Object.keys(ownerItems).map(key => ({ text: ownerItems[key] , value: key})).sort((a, b) => a.text.localeCompare(b.text))
            },

            projectModuleData () {
                return this.projectDetails ? this.projectDetails.modinfo : {};
            },

            currentTab () {
                return this.items[this.tab];
            },

            statusSelectOptions () {
                return Object.keys(this.statusItems).map((key) => ({
                    value: key,
                    text: this.statusItems[key]
                })).filter((option) => ['not_started', 'not_applicable'].includes(option.value));
            },

            // formattedNotes: {
            //     get() {
            //         return this.project_step.tasks.notes.replace(/''/g, "'");
            //     },
            //     set(value) {
            //         this.project_step.tasks.notes = value;
            //         // this.$emit('update:notes', value);
            //     }
            // }
        },

        data () {
            return {
                calendlyDialog: false,
                reorderTasksDialog: false,
                projectTaskDialog: false,
                projectReportStepDialog: false,
                projectReportMeetingDialog: false,
                showTasks: false,
                showAllTaskRows: false,
                project_id: '',
                printablePrj: Object,
                print_version: false,
                projectStepData: [],
                this_Milestone: {},
                editedItem: {},
                editedStep: {},
                editedMeeting: {},
                readyToLoad: false,
                items: ['tab_steps', 'tab_meetings'],
                headers: [
                    {
                        text: 'Task',
                        sortable: false,
                        value: 'label',
                        class: 'header-class-left first-column-padding'
                    },
                    { 
                        text: 'Status',
                        value: 'status_label',
                        sortable: false,
                        class: 'header-class-left status-width'
                    },
                    { 
                        text: 'Priority',
                        value: 'priority',
                        align: 'start',
                        sortable: false,
                        class: 'header-class-left priority-width'
                    },
                    { 
                        text: 'Complexity', 
                        value: 'complexity',
                        sortable: false,
                        class: 'header-class-left complexity-width'
                    },
                    { 
                        text: 'Responsibility', 
                        value: 'responsible_party_label',
                        sortable: false,
                        class: 'header-class-left responsibility-width'
                    },
                    { 
                        text: 'Owner',
                        value: 'owner_name',
                        sortable: false,
                        class: 'header-class-left owner-width'
                    },
                    { 
                        text: 'Internal Only', 
                        value: 'internal', 
                        align: 'center',
                        sortable: false,
                        class: 'header-class-center internal-width'
                    },
                    {
                        text: 'Duration', 
                        value: 'duration',
                        sortable: true,
                        class: 'header-class-center duration-width'
                    },{
                        text: 'Due Date', 
                        value: 'date_label',
                        sortable: false,
                        class: 'header-class-right due-date-width'
                    },
                    { 
                        text: "Assigned Date",
                        value: "assigned_date",
                        sortable: false, 
                        class: 'header-class-right assigned-date-width'
                    },
                    { 
                        text: "Completed Date",
                        value: "completed_date",
                        sortable: false, 
                        class: 'header-class-right completed-date-width'
                    },
                    {
                        text: "Visibility",
                        value: 'is_visible',
                        class: 'header-class-right actions-width'
                    }
                ],
                meeting_headers: [
                    {
                        text: 'Meeting',
                        align: 'left',
                        sortable: true,
                        value: 'label',
                        width: '35%'
                    },
                    {
                        text: 'Non-Calendly Reason',
                        align: 'left',
                        sortable: true,
                        value: 'non_calendly_reason',
                        width: '35%'
                    },
                    { 
                        text: 'Date / Time', 
                        value: 'start_time',
                        sortable: true,
                        width: '15%'
                    },
                    { 
                        text: 'Status', 
                        value: 'status',
                        sortable: true,
                        width: '8%'
                    },
                    {
                        value: 'actions',
                        align: 'right',
                        width: '7%'
                    }
                ],
                meetingData: [],
                meeting_options: {
                    sortBy: ['status','start_time'],
                    sortDesc: [true, true],
                    multiSort: true,
                    itemsPerPage: -1,
                },
                tab: 'steps',
                labels: {
                    tab_steps: 'Project Steps',
                    tab_meetings: 'Meetings',
                    
                    step_party_srg: 'SRG',
                    step_party_client: 'Client',
                    // step_party_both: 'Both',
                    step_party_broker_dealer: 'Broker Dealer',
                    step_party_custodian: 'Custodian',
                    step_party_accountant: 'Accountant',
                    step_party_attorney: 'Attorney',
                    step_party_other: 'Other',
                    step_party_not_applicable: 'Not Applicable',
                    
                    step_status_not_started: 'Not Started',
                    step_status_on_deck: 'On Deck',
                    step_status_scheduled: 'Scheduled',
                    step_status_on_deck: 'On Deck',
                    step_status_in_progress: 'In Progress',
                    step_status_completed: 'Completed',
                    step_status_not_applicable: 'Not Applicable',
                    
                    step_complexity_low: 'Low',
                    step_complexity_medium: 'Medium',
                    step_complexity_high: 'High',

                    step_priority_normal: 'Normal',
                    step_priority_urgent: 'Urgent',
                    step_priority_backburner: 'Back Burner',
                    step_priority_annual: 'Annual',
                },
                meetingStatusItems: meetingStatusItems,
                responsiblePartyItems: responsiblePartyItems,
                statusItems: taskStatusItems,
                priorityItems: priorityItems,
                complexityItems: complexityItems,
                ownerItems: ownerItems,

                // complexityList: Object.keys(complexityItems).map(key => ({ text: complexityItems[key] , value: key})),
                // priorityList: Object.keys(priorityItems).map(key => ({ text: priorityItems[key] , value: key})),
                // responsiblePartiesList: Object.keys(responsiblePartyItems).map(key => ({ text: responsiblePartyItems[key] , value: key})),
                // taskTypesList: Object.keys(taskTypes).map(key => ({ text: taskTypes[key] , value: key})),
                // durationList: Object.keys(durationItems).map(key => ({ text: durationItems[key] , value: key})),

                users_sortorder: ['owner', 'secondary', 'partner'],
                meetingTimeOptions: {
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    hour12: true,
                    hour: 'numeric',
                    minute: '2-digit',
                    timeZoneName: 'short'
                },
                chooseLeadOnMeeting: false,
                enterprise_consulting_meetingURL: '',
            }
        },

        mounted () {
            this.setupCalendlyListener();
            this.getStatusReport();


            if ( this.$route.name == 'printable_psr_report' ) {
                this.print_version = true
                this.getProjectData()
            }
        },
        
        methods: {
            saveMeetingWithLead () {
                console.log('Saving meeting with lead:', this.editedMeeting.lead_id);
                const leadId = this.editedMeeting.lead_id;
                if (leadId) {
                    this.editedMeeting.item.lead_id = leadId;
                    const lead_url = this.projectDetails.project_team.find( member => member.user_id === leadId );
                    this.enterprise_consulting_meetingURL = lead_url ? lead_url.cal_link : '';
                    
                    this.chooseLeadOnMeeting = false;
                    this.calendlyDialog = true;
                } else {
                    // Handle case where no lead is selected, if necessary
                    console.warn('No lead selected for the meeting.');
                }
            },

            dialogTitle ( drawer ) {
                if (drawer === 'projectReportStepDialog') {
                    return 'Create a new Milestone';
                } else if (drawer === 'projectTaskDialog') {
                    return this.editedItem.task_id ? 'Edit Task' : 'Add Task';
                } else if (drawer === 'projectReportMeetingDialog' || drawer === 'calendlyDialog') {
                    return 'Schedule a Meeting';
                } else if (drawer === 'reorderTasksDialog') {
                    return 'Reorder Tasks';

                }
            },

            closeNavigationDrawer( drawer ) {
                if (drawer === 'projectReportStepDialog') {
                    this.projectReportStepDialog = false;
                } else if (drawer === 'projectTaskDialog') {
                    this.projectTaskDialog = false;
                } else if (drawer === 'projectReportMeetingDialog') {
                    this.projectReportMeetingDialog = false;
                } else if (drawer === 'calendlyDialog') {
                    this.closeCalendly();
                } else if (drawer === 'reorderTasksDialog') {
                    this.reorderTasksDialog = false;
                }
            },

            isTaskVisible (task) {
                if (!task) return false;

                if (!Object.prototype.hasOwnProperty.call(task, 'is_visible')) {
                    return true;
                }

                const { is_visible } = task;

                if (typeof is_visible === 'boolean') return is_visible;
                if (typeof is_visible === 'number') return is_visible === 1;
                if (typeof is_visible === 'string') {
                    const normalized = is_visible.trim().toLowerCase();
                    return normalized === '1' || normalized === 'true';
                }

                return !!is_visible;
            },

            visibleTaskCount (tasks) {
                return (tasks || []).filter((task) => this.isTaskVisible(task)).length;
            },

            hasHiddenTasks (tasks) {
                return (tasks || []).some((task) => !this.isTaskVisible(task));
            },

            visibleTasks (tasks) {
                if (this.showAllTaskRows) {
                    return tasks || [];
                }

                return (tasks || []).filter((task) => this.isTaskVisible(task));
            },

            showAllTasks () {
                this.showAllTaskRows = !this.showAllTaskRows;
            },

            async toggleMilestoneTasks (projectStep, action) {
                if (!projectStep || !projectStep.tasks || !projectStep.tasks.length) {
                    return;
                }

                const shouldShowAll = !!action;

                const targetTasks = projectStep.tasks.filter((task) => {
                    if (shouldShowAll) {
                        return !this.isTaskVisible(task);
                    }

                    return this.isTaskVisible(task) && ['not_applicable', 'completed'].includes(task.status);
                });

                if (!targetTasks.length) {
                    return;
                }

                await axios.put(
                    `${appUrls.api}/api/admin/task/visibility`,
                    {
                        task_ids: targetTasks.map((task) => task.task_id),
                        is_visible: shouldShowAll
                    },
                    {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    }
                );

                this.projectStepData = this.projectStepData.map((step) => {
                    if (step.projectstep_id !== projectStep.projectstep_id) {
                        return step;
                    }

                    const tasks = (step.tasks || []).map((task) => {
                        if (shouldShowAll) {
                            return {
                                ...task,
                                is_visible: true
                            };
                        }

                        if (['not_applicable', 'completed'].includes(task.status)) {
                            return {
                                ...task,
                                is_visible: false
                            };
                        }

                        return task;
                    });

                    return {
                        ...step,
                        tasks
                    };
                });

                this.triggerUserFeedback(true, shouldShowAll ? 'All tasks for this milestone are now visible' : 'All completed and not applicable tasks for this milestone have been hidden');
            },

            async updateTaskStatus (projectStep, task, nextStatus) {
                if (!projectStep || !task || !nextStatus || task.status === nextStatus) {
                    return;
                }

                const previousStatus = task.status;

                this.projectStepData = this.projectStepData.map((step) => {
                    if (step.projectstep_id !== projectStep.projectstep_id) {
                        return step;
                    }

                    const tasks = (step.tasks || []).map((thisTask) => {
                        if (thisTask.task_id === task.task_id) {
                            return {
                                ...thisTask,
                                status: nextStatus
                            };
                        }

                        return thisTask;
                    });

                    return {
                        ...step,
                        tasks
                    };
                });

                const payload = {
                    complexity: task.complexity,
                    date: task.date,
                    duration: task.duration,
                    internal: task.internal,
                    label: task.label,
                    order_number: task.order_number,
                    owner_id: task.owner_id,
                    priority: task.priority,
                    projectstep_id: projectStep.projectstep_id,
                    responsible_party: task.responsible_party,
                    status: nextStatus,
                    is_visible: task.is_visible,
                    task_id: task.task_id,
                    notes: task.notes,
                    previous_data: {
                        ...task,
                        status: previousStatus
                    },
                    isSRG: true
                };

                try {
                    await axios.put(`${appUrls.api}/api/project_step/${projectStep.projectstep_id}/task/${task.task_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        payload
                    });
                } catch (error) {
                    this.projectStepData = this.projectStepData.map((step) => {
                        if (step.projectstep_id !== projectStep.projectstep_id) {
                            return step;
                        }

                        const tasks = (step.tasks || []).map((thisTask) => {
                            if (thisTask.task_id === task.task_id) {
                                return {
                                    ...thisTask,
                                    status: previousStatus
                                };
                            }

                            return thisTask;
                        });

                        return {
                            ...step,
                            tasks
                        };
                    });

                    this.triggerUserFeedback(true, 'Unable to update task status', 'accent');
                }
            },

            async getStatusReport () {
                try {                
                    const project_id = this.projectDetails != undefined ? this.projectDetails.project_id : this.$route.params.pid;
                    const status_report = await axios.get(`${appUrls.api}/api/admin/project/${project_id}/project_status_report`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    });

                    const { data } = status_report;
                    // console.log(data)
                    const { projectSteps, meetings } = data;

                    this.meetingData = meetings;
                    this.projectStepData = projectSteps;
                    this.showTasks = true;
                    if ( !this.print_version ) this.readyToLoad = true
                } catch ( error ) {
                    console.log(error);
                }
            },

            async getProjectData () {
                const project_data = await axios.get(`${appUrls.api}/api/printable_project/${this.$route.params.pid}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                });
                this.printablePrj = project_data.data.project_data;

                // // PROJECT TITLE & INTERNAL TITLE
                const internal_title = this.printablePrj.internal_project_title != null ? this.printablePrj.internal_project_title.length >= 56 ? ` :: ${this.printablePrj.internal_project_title.substr(0, 53)}<br>${this.printablePrj.internal_project_title.substr(54,this.printablePrj.internal_project_title.length)}` : this.printablePrj.internal_project_title : ''
                const user_prj_title = this.printablePrj.project_title != null ? this.printablePrj.project_title.length >= 56 ? ` :: ${this.printablePrj.project_title.substr(0, 53)}<br>${this.printablePrj.project_title.substr(54,this.printablePrj.project_title.length)}` : this.printablePrj.project_title : ''
                const mod_divider    = user_prj_title != '' ? ' :: ' : ''
                const project_label  = `<div class="sansation d-flex justify-space-between ma-0 pa-0">
                    <div class="ma-0 pa-0"><span class="primary--text text--darken-2 font-weight-bold">${this.printablePrj.modinfo.module_name}</span><span class="font-weight-thin grey--text">${mod_divider}${user_prj_title}</span></div>
                    </div>`
                // const mod_divider    = internal_title != '' || user_prj_title != '' ? ' :: ' : ': '
                // const title_divider  = internal_title != '' && user_prj_title != '' ? ' :: ' : ''
                // const project_label  = `<div class="sansation d-flex justify-space-between ma-0 pa-0">
                //         <div class="ma-0 pa-0"><span class="primary--text text--darken-2 font-weight-bold">${this.printablePrj.modinfo.module_name}</span><span class="font-weight-thin grey--text">${mod_divider}${internal_title}</span><span class="font-weight-thin grey--text text--darken-2">${title_divider}${user_prj_title}</span></div>
                //         </div>`
                this.printablePrj.project_label = project_label

                this.printablePrj.project_owners          = this.printablePrj.users.filter( user => user.user_type == 'owner' )
                this.printablePrj.project_secondary_users = this.printablePrj.users.filter( user => user.user_type == 'secondary' )
                this.printablePrj.project_partners        = this.printablePrj.users.filter( user => user.user_type == 'partner' )

                this.readyToLoad = true
            },
            
            formatDate: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },


            formatDateTime ( date_to_format ) {
                const options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                    timeZoneName: 'short'  // time zone abbreviation
                }
                // const formatted = dateObj.toLocaleString(undefined, options).replace(/\bAM\b/, 'am').replace(/\bPM\b/, 'pm'); // undefined or use specific locale like 'en-US'

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },

            removeAllMilestones () {
                if (confirm('Are you sure you want to remove all milestones and tasks for this project?')) {
                    const project_id = this.projectDetails.project_id;
                    axios.delete(`${appUrls.api}/api/admin/project/${project_id}/psr`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    }).then(() => {
                        this.getStatusReport();
                    });
                }
            },

            getRelatedItem (item) {
                const { task_type, related_item_id } = item;

                if (task_type === taskTypes.meeting && related_item_id) {
                    return this.meetingData.find((thisMeeting) => thisMeeting.meeting_id === related_item_id);
                }
            },

            openMeetingDialog () {
                this.editMeeting({
                    project_id: this.projectDetails.project_id
                });
            },

            openStepDialog ( milestone ) {
                if ( milestone && milestone.hasOwnProperty('projectstep_id') ) {
                    this.editedStep = { 
                        projectstep_id: milestone.projectstep_id
                    };
                } else {
                    this.editedStep = {
                        project_id: this.projectDetails.project_id,
                        order_number: this.projectStepsComputed.length + 1
                    };
                }
                this.projectReportStepDialog = true;
            },

            openTaskDialog ( project_step ) {
                this.this_Milestone = project_step;
                this.reorderTasksDialog = true;
            },

            createTask(parent) {
                const newTask =  {
                    isNew: true,
                    name: '',
                    order_number: parent.tasks.length + 1,
                    task_type: 'general',
                    internal: true,
                    is_visible: true
                }
                this.editTask(parent, newTask);
            },

            // editTask (item) {            
            //     this.editedItem = { 
            //         item
            //     };
            //     this.$refs.projectReportDialog.open();
            // },

            editTask(parent, item) {
                this.editedItem = {
                    ...item,
                    projectstep_id: parent.projectstep_id
                };
                this.projectTaskDialog = true;
            },

            editMeeting (item) {            
                this.editedMeeting = { 
                    item
                };
                
                this.projectReportMeetingDialog = true;
            },

            scheduleMeeting (item) {
                // console.log(item)
                this.editedMeeting = { 
                    item
                };
                
                if ( this.projectDetails.modinfo.module_key === 'enterprise-consulting' ) {
                    this.chooseLeadOnMeeting = true;
                } else {
                    this.calendlyDialog = true;
                }
            },

            initCalendlyWidget (attempt = 0) {
                this.$nextTick(() => {
                    const wrapper = this.$refs.calendlyWrapper;
                    const calendlyReady = typeof Calendly !== 'undefined' && Calendly && typeof Calendly.initInlineWidget === 'function';
                    const wrapperReady = !!wrapper;
                    const drawerVisible = this.calendlyDialog;

                    if (!calendlyReady || !wrapperReady || !drawerVisible) {
                        if (attempt < 25) {
                            setTimeout(() => this.initCalendlyWidget(attempt + 1), 100);
                        }
                        return;
                    }

                    wrapper.innerHTML = '';

                    Calendly.initInlineWidget({
                        url: this.meetingURL,
                        parentElement: wrapper
                    });
                });
            },

            closeCalendly () {
                this.calendlyDialog = false;
                const wrapper = this.$refs.calendlyWrapper;
                if (wrapper) {
                    wrapper.innerHTML = '';
                }
            },

            setupCalendlyListener() {
                // Remove any existing listeners
                calendlyListeners.forEach((listener, i) => {
                    window.removeEventListener('message', listener);
                    calendlyListeners.splice(i, 1);
                });

                // Add a new listener in this context and track it
                window.addEventListener('message', this.receiveCalendlyMessage);
                calendlyListeners.push(this.receiveCalendlyMessage);
            },

            async receiveCalendlyMessage (event) {
                /**
                 * {
                    event: "calendly.event_scheduled",
                    payload: {
                        event: {
                        uri: "https://api.calendly.com/scheduled_events/ABCDABCDABCDABCD"
                        },
                        invitee: {
                        uri: "https://api.calendly.com/api/v2/scheduled_events/ABCDABCDABCDABCD/invitees/ABCDABCDABCDABCD"
                        }
                    }
                    }
                */

                const { data } = event;
                const { event: eventType, payload } = data;
                // Ensure the message is from the Calendly iframe
                if (!eventType || eventType.indexOf('calendly') < 0) {
                    return;
                }

                if (eventType === 'calendly.event_scheduled') {
                    // console.log(payload)
                    const calendly_event_id = payload.event.uri.split('/').pop();
                    const calendly_invitee_id = payload.invitee.uri.split('/').pop();
                    const { item } = this.editedMeeting;
                    const {  meeting_id } = item;

                    await axios.put(
                        `${appUrls.api}/api/admin/meeting/${meeting_id}`,
                        {
                            calendly_invitee_id,
                            calendly_event_id,
                            status: 'scheduled'
                        },
                        {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        }
                    );
                }

                // Do something with the received data (e.g., the selected date)
                // console.log('Received Calendly Data:', eventType, payload);
            },

            printPsrWindow () {
                let route = this.$router.resolve({ path: `/${this.projectDetails.project_id}/printable_psr_report`});
                window.open(route.href, '_blank');
            },

            printPsrReport () {
                window.addEventListener("beforeprint", (event) => {
                    const user_prj_title = this.printablePrj.project_title != null ? this.printablePrj.project_title.trim().replaceAll(' ', '-')+'_' : ''
                    const user_name_title = `${this.printablePrj.project_owners[0].first_name.trim()}-${this.printablePrj.project_owners[0].last_name.trim()}`
                    const module_title = this.printablePrj.modinfo.module_name.replaceAll(' ', '-')
                    const date = new Date();
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${date.getFullYear()}`

                    document.title = `${user_prj_title}${user_prj_title == '' ? user_name_title+'_' : ''}${module_title}_${formattedDate}`
                });

                window.addEventListener("afterprint", (event) => {
                    document.title = `SRG ${this.printablePrj.modinfo.module_name} Project Status Report`
                });
                
                window.print()
            },

            async hideTask (task, is_visible_value) {
                const action = is_visible_value ? 'unhide' : 'hide';
                // if (confirm(`Are you sure you want to ${action} this task?`)) {
                    await axios.put(`${appUrls.api}/api/admin/task/visibility`, 
                    {
                        task_ids: [task.task_id],
                        is_visible: is_visible_value
                    },
                    {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    this.projectStepData = this.projectStepData.map((projectStep) => {
                        const tasks = (projectStep.tasks || []).map((thisTask) => {
                            if (thisTask.task_id === task.task_id) {
                                return {
                                    ...thisTask,
                                    is_visible: is_visible_value
                                };
                            }

                            return thisTask;
                        });

                        return {
                            ...projectStep,
                            tasks
                        };
                    });
                // }
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },

            printClose () {
                window.close()
            },

            close () {
                setTimeout(() => {
                    this.editedItem = {};
                    this.projectTaskDialog = false;
                    this.projectReportMeetingDialog = false;
                    this.projectReportStepDialog = false;
                    this.reorderTasksDialog = false;
                }, 300);
            },

            async save () {
                this.projectTaskDialog = false;
                this.getStatusReport();
            },

            async loadNextTask ( nextTask ) {
                if ( !nextTask || !nextTask.task_id ) {
                    this.projectTaskDialog = false;
                    this.getStatusReport();
                    return;
                }

                this.editedItem = { ...nextTask };
                this.projectTaskDialog = true;
                this.getStatusReport();
            }
        }
    }
</script>

<style>
    #calendly_wrapper {
        height: 1100px;
        padding: 0;
        margin: 0;
        background-color: whitesmoke !important;
    }
</style>

<style scoped>
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .icon-phone {
        /* color: #e8f0d7; */
        color: #fbfdfd;
    }
    .icon-center {
        margin: 0 auto;
    }
    .icon-size {
        min-width: 3rem;
        max-width: 3rem;
    }
    .icon-size-small {
        min-width: 2.5rem;
        max-width: 2.5rem;
    }
    .icon-size-header {
        min-width: 2.5rem;
        max-width: 2.5rem;
	}
	.project_title {
		font-size: 1.12rem !important;
	}
    .table_borders {
        border-right: 1px solid #CCC;
        border-bottom: 1px solid #CCC;
        border-left: 1px solid #CCC;
    }
    .header-class-left {
        color: #666 !important;
        font-size: .75rem !important;
        padding: 9px 0 !important;
        text-align: left !important;
        vertical-align: top !important;
        border-bottom: 1px solid #DDD !important;
    }
    .header-class-center {
        color: #666 !important;
        font-size: .75rem !important;
        padding: 9px 0 !important;
        text-align: center !important;
        vertical-align: top !important;
        border-bottom: 1px solid #DDD !important;
    }
    .header-class-right {
        color: #666 !important;
        font-size: .75rem !important;
        padding: 9px 0 !important;
        text-align: right !important;
        vertical-align: top !important;
        border-bottom: 1px solid #DDD !important;
    }
    .psr_data_class {
        padding: 9px 0 !important;
        vertical-align: top !important;
        font-family: 'AvenirBook' !important;
    }
    .first-column-padding {
        padding: 9px !important;
    }
    .text-start {
        text-align: left;
    }
    .text-end {
        text-align: right;
    }
    .status-width {
        width: 10%;
    }
    .priority-width {
        width: 11%;
    }
    .complexity-width {
        width: 6%;
    }
    .responsibility-width {
        width: 7%;
    }
    .owner-width {
        width: 8%;
    }
    .internal-width {
        width: 4%;
    }
    .duration-width {
        width: 4%;
    }
    .due-date-width {
        width: 5%;
    }
    .assigned-date-width {
        width: 7%;
    }
    .completed-date-width {
        width: 7%;
    }
    .actions-width {
        width: 4%;
    }
    .delete_forever_link {
        cursor: pointer;
        color: #D9D9D9;
        border-radius: 0 5px 5px 0;
    }
    .delete_forever_link :hover {
        color: orangered;
        background-color: #FCE4EC !important;
        border-radius: 0 5px 5px 0;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .inline_status_select >>> .v-input__control {
        padding: 0 !important;
        font-size: x-small !important;
    }
    .inline_status_select >>> .v-select__selections {
        padding: 0 !important;
        font-size: small !important;
    }
    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectReport.vue